import React from "react";

import { Fade } from "react-reveal";
import styled from "styled-components";

const ProjectCard = ({ index, onTap, data }) => {
  return (
    <Fade bottom duration={index * 500}>
      <ProjectCardContainer>
        <img
          src={require("../../../assets/images/" + data.img)}
          alt="Project"
        ></img>

        <div>
          <h3>{data.name}</h3>
          <h4>{data.desc}</h4>
          <h5>{data.platform}</h5>
          <SocialIconRow>
            {data.apple !== "" ? (
              <SocialIcon href={data.apple} target="_blank">
                <img
                  src={require("../../../assets/images/apple.png")}
                  alt={data.apple}
                ></img>
              </SocialIcon>
            ) : (
              <div />
            )}
            {data.google !== "" ? (
              <SocialIcon href={data.google} target="_blank">
                <img
                  src={require("../../../assets/images/google-play.png")}
                  alt={data.google}
                ></img>
              </SocialIcon>
            ) : (
              <div />
            )}
            {data.github !== "" ? (
              <SocialIcon href={data.github} target="_blank">
                <img
                  src={require("../../../assets/images/github.png")}
                  alt={data.github}
                ></img>
              </SocialIcon>
            ) : (
              <div />
            )}
            {data.websiteUrl !== undefined &&
            data.websiteUrl !== null &&
            data.websiteUrl !== "" ? (
              <SocialIcon href={data.websiteUrl} target="_blank">
                <img
                  src={require("../../../assets/images/browser.png")}
                  alt={data.websiteUrl}
                ></img>
              </SocialIcon>
            ) : (
              <div />
            )}
          </SocialIconRow>
          {data.snaps.length > 0 ? (
            <h2 href={null} onClick={onTap}>
              Preview
            </h2>
          ) : (
            <div />
          )}
        </div>
      </ProjectCardContainer>
    </Fade>
  );
};

export default ProjectCard;

const ProjectCardContainer = styled.div`
  padding: 0;
  border-radius: 10px;
  position: relative;
  border: 1px solid var(--hoverback);
  margin: 0px 10px 10px 0px;

  & > img {
    opacity: 1;
    display: block;
    height: auto;
    border-radius: 10px;
    transition: 0.5s ease;
    backface-visibility: hidden;
    height: 200px;
    width: 100%;
    object-fit: fill;

    /* @media (max-width: 500px) {
      height: 100%;
      object-fit: cover;
    } */
  }

  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    position: absolute;
    bottom: 100%;
    left: 0;
    right: 0;
    overflow: hidden;
    width: 100%;
    height: 0;
    transition: 0.5s ease;
    text-align: center;
    opacity: 0;
    background-color: var(--primary);

    & > h3 {
      padding: 15px 10px 10px 10px;
      color: black;
      font-size: 20px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    & > h4 {
      color: black;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      padding: 0px 10px 0px 10px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: 12px;
    }
    & > h5 {
      padding: 8px 10px 10px 10px;

      text-align: center;
      font-size: 12px;

      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      font-weight: bold;
    }

    & > h2 {
      max-width: 70px;
      align-self: center;
      margin-top: 5px;
      margin-bottom: 10px;
      padding: 10px 20px;
      border-radius: 10px;
      color: var(--secondary);
      background-color: var(--black);
      text-align: center;
      text-decoration: none;
      font-size: 12px;
    }
  }

  &:hover > img {
    opacity: 0.3;
  }
  &:hover > div {
    border-radius: 10px;
    opacity: 0.8;
    bottom: 0;
    height: 100%;
  }
`;

const SocialIcon = styled.a`
  & > img {
    padding: 5px 10px;
    height: 20px;
    width: 20px;
  }
  :hover {
    border-radius: 10px;
    opacity: 0.8;
  }
`;

const SocialIconRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
